/** filters actions constants */
export const SET_TOOGLE_FILTER_STATE = 'Catalog::Filters::Toggle';
export const SET_UPDATE_FILTER_ACTIVE_OPTION = 'Catalog::Filters::ToggleOption';
export const SET_FILTER_SHOW_ALL_OPTIONS = 'Catalog::Filters::ShowAllOptions';
export const SET_FILTER_RANGE_VALUES = 'Catalog::Filters::SetRangeValues';
export const SET_FILTER_VALUES = 'Catalog::Filters::SetValues';
export const DISABLE_FILTERS = 'Catalog::Filters::DisableFilters';
export const FORCE_REMAINS_ONLY = 'Catalog::Filters::ForceRemainsOnly';

export const FILTER_SLUG_PRICE = 'price';
export const FILTER_SLUG_BRAND = 'proizvoditel';
